import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { formatSegmentationResponse } from "../../utils/segmentation-utils";

export function useSegmentationById() {
    const [segmentation, setSegmentation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchSegmentationById(segmentationId) {
        if (!segmentationId) {
            setSegmentation(null);
            setError("Não foi possível identificar a segmentação.");

            return {
                ok: false,
                reason: "validation",
                error: "Não foi possível identificar a segmentação."
            };
        }

        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível carregar os dados da segmentação."
                );
            }

            const data = await response.json();

            const segmentationData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedSegmentation = formatSegmentationResponse(segmentationData);

            setSegmentation(formattedSegmentation);

            return {
                ok: true,
                segmentation: formattedSegmentation
            };
        } catch (requestError) {
            setSegmentation(null);
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        segmentation,
        loading,
        error,
        fetchSegmentationById
    };
}